import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=a3edc9d2&scoped=true&lang=pug&"
import script from "./Logout.vue?vue&type=script&lang=ts&"
export * from "./Logout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edc9d2",
  null
  
)

export default component.exports